export const CURRENCY_SIGN = {
  USD: '$',
};
